<template>
  <main class="bg-white text-gray-800">
    <!-- About Section -->
    <section
      class="max-w-6xl mx-auto px-2 py-16 grid md:grid-cols-2 gap-4 items-center"
    >
      <div>
        <p class="text-sm md:text-base leading-relaxed mb-4 lg:px-0 px-4">
          Lisa Suite is curated to provide guests with all the comforts of home,
          plus the added convenience of having a concierge and associates
          dedicated to making your stay as comfortable and enjoyable as
          possible.
        </p>
        <p class="text-sm md:text-base leading-relaxed lg:px-0 px-4">
          This premier serviced apartment company offers luxurious and
          comfortable accommodations for both national and international guests,
          providing them with comfort, convenience, and professional services in
          a serene and prestigious environment. Lisa Suite boasts 55 elegantly
          designed rooms and deluxe suites, a conference centre, and a rooftop
          lounge. Guests also enjoy access to an in-house restaurant, salon,
          gym, cinema, pool, and outdoor bar.
        </p>

        <!-- Mission & Vision -->
        <div class="grid md:grid-cols-2 gap-4 mt-8 lg:px-0 px-4">
          <div class="bg-white shadow-md rounded-xl py-4 px-2 text-center">
            <div
              class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-indigo-100 text-indigo-600 rounded-full"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <h3 class="font-semibold text-lg mb-2">Our Mission</h3>
            <p class="text-sm">
              To provide you with exceptional service that satisfies your quest
              for happiness.
            </p>
          </div>
          <div class="bg-white shadow-md rounded-xl py-4 px-2 text-center">
            <div
              class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-indigo-100 text-indigo-600 rounded-full"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <h3 class="font-semibold text-lg mb-2">Our Vision</h3>
            <p class="text-sm">
              Lisa Suites strive to create an apart-hotel that provides
              exceptional hospitality experience that leaves you with sweet
              memories.
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 grid-rows-2 gap-4 h-[500px]">
        <img
          src="../assets/images/Lisa_48.jpg"
          alt="Home 1"
          class="rounded-2xl w-full h-full object-cover row-span-2"
        />
        <img
          src="../assets/images/Lisa_43.jpg"
          alt="Home 2"
          class="rounded-2xl w-full h-full object-cover"
        />
        <img
          src="../assets/images/Lisa_23.jpg"
          alt="Home 3"
          class="rounded-2xl w-full h-full object-cover"
        />
      </div>
    </section>

    <!-- Core Values -->
    <section class="bg-gray-100 py-16 text-center">
      <h2 class="text-2xl md:text-3xl font-semibold mb-10">Our Core Values</h2>
      <div class="flex flex-col md:flex-row justify-center gap-8 px-6">
        <div
          class="bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">Customer Satisfaction</p>
        </div>
        <div
          class="bg-gradient-to-r from-orange-400 to-orange-300 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">Professionalism/Excellence</p>
        </div>
        <div
          class="bg-gradient-to-r from-cyan-400 to-sky-400 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">Diligence/Commitment</p>
        </div>
        <div
          class="bg-gradient-to-r from-yellow to-yellow text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">Sincerity/Honesty</p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
